"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkGraphicsComponents = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_graphics_component_type_1 = require("./e-graphics-component-type");
/**
 * @public
 * Shares compatible buffers between components, so updates to one affect all.
 */
function linkGraphicsComponents(graphicsComponents) {
    if (graphicsComponents.length < 2) {
        DEBUG_MODE && rc_js_util_1._Debug.error("attempted to link to nothing...");
        return;
    }
    const bindersToLink = new Map();
    const gcGroups = new Map();
    for (let i = 0, iEnd = graphicsComponents.length; i < iEnd; ++i) {
        const graphicsComponent = graphicsComponents[i];
        DEBUG_MODE && rc_js_util_1._Debug.assert(graphicsComponent.type === e_graphics_component_type_1.EGraphicsComponentType.Entity, "expected entity renderer");
        const binders = graphicsComponent.getLinkableBinders();
        if (binders.length === 1) {
            rc_js_util_1._Map.push(gcGroups, binders[0].linkId, graphicsComponent);
        }
        for (let j = 0, jEnd = binders.length; j < jEnd; ++j) {
            const binder = binders[j];
            rc_js_util_1._Map.push(bindersToLink, binder.linkId, binder);
        }
    }
    for (const linkableBinders of bindersToLink.values()) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const last = linkableBinders.pop();
        last.link(linkableBinders);
    }
    for (const linkableGcs of gcGroups.values()) {
        const groupId = linkableGcs[0].transform.groupId;
        for (let i = 1, iEnd = linkableGcs.length; i < iEnd; ++i) {
            linkableGcs[i].transform.setGroupId(groupId);
        }
    }
}
exports.linkGraphicsComponents = linkGraphicsComponents;
//# sourceMappingURL=link-graphics-components.js.map